export const adminUserKeys = {
  all: ['admin-users'] as const,
  list: ['admin-users', 'list'] as const,
};
